<script lang="ts" setup>
	import {
		Dialog,
		DialogPanel,
		DialogTitle,
		TransitionChild,
	} from '@headlessui/vue'

	interface Props {
		actualDisclaimer: string
	}

	interface Emits {
		(e: 'close'): void
	}

	const emits = defineEmits<Emits>()
	defineProps<Props>()
</script>

<template>
	<Dialog
		as="div"
		class="relative z-50"
		@close="emits('close')"
	>
		<TransitionChild
			as="template"
			enter="duration-300 ease-out"
			enter-from="opacity-0"
			enter-to="opacity-100"
			leave="duration-200 ease-in"
			leave-from="opacity-100"
			leave-to="opacity-0"
		>
			<div class="fixed inset-0 bg-black bg-opacity-25" />
		</TransitionChild>

		<div class="fixed inset-0 overflow-y-auto">
			<div class="flex min-h-full items-center justify-center p-4 text-center">
				<TransitionChild
					as="template"
					enter="duration-300 ease-out"
					enter-from="opacity-0 scale-95"
					enter-to="opacity-100 scale-100"
					leave="duration-200 ease-in"
					leave-from="opacity-100 scale-100"
					leave-to="opacity-0 scale-95"
				>
					<DialogPanel
						class="w-full max-w-md transform select-none overflow-hidden rounded-xl bg-gray-50 p-6 text-right align-middle text-gray-900 shadow-xl transition-all"
					>
						<DialogTitle
							as="h3"
							class="flex items-center gap-2 text-xl font-semibold leading-6"
						>
							<span class="material-symbols-outlined text-yellow-400">
								warning
							</span>
							Aviso
						</DialogTitle>
						<div class="mt-4">
							<p class="text-justify text-sm">
								{{ actualDisclaimer }}<span class="text-red-600">*</span>
							</p>
						</div>

						<div class="mt-2">
							<button
								type="button"
								class="ml-auto inline-flex justify-center rounded-md border border-transparent bg-yellow-200 px-4 py-2 text-sm font-medium text-yellow-900 hover:bg-yellow-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400 focus-visible:ring-offset-2"
								@click="emits('close')"
							>
								Entendido
							</button>
						</div>
					</DialogPanel>
				</TransitionChild>
			</div>
		</div>
	</Dialog>
</template>
